import styled from 'styled-components';
import Feedback from 'products/nomad_insurance/components/Feedback';

export const StyledFeedback = styled(Feedback)`
  margin-top: 16px;
  max-width: 520px;
`;
